import React from 'react'
import {IntermediaryInfo} from '../repository/NatGetOwnershipTransfer'
import { Box, TableRow } from '@mui/material';
import {FontWeights} from '../../../../styledComponents/Constants'
import {
    SecondaryTableCell,
    SecondaryTableRowName,
    TableRowName,
    TableRowNameTop
} from '../../../../styledComponents/adminPage/Table'
import moment from 'moment'
import {getFormattedAddress} from '../../../common/util/Natutil'
import {Nullable} from '../../../../app/TypeHelpers'
import {ROLE_FOR_ADMINISTRATOR} from '../../../../CodeMaster'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    intermediaryInfo: Nullable<IntermediaryInfo>
}

export const NatOwnershipTransferApplyDetailByIntermediary: React.FC<Props> = props => {
    const roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)
    const lmFlag = roleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value

    if (!props.intermediaryInfo) {
        return (
            <TableRow>
                <TableRowName>
                    <Box fontWeight={FontWeights.Bold}>仲介業者</Box>
                </TableRowName>
                <SecondaryTableCell colSpan={4} end>
                    入力されていません。
                </SecondaryTableCell>
            </TableRow>
        )
    }

    const {
        ownershipTransferDate,
        oldMemberPaymentChangeDate,
        newMemberPaymentChangeDate,
        companyName,
        intermediaryZipCode,
        intermediaryPrefecture,
        intermediaryAddress2,
        intermediaryAddress3,
        intermediaryBuildingRoomNumber,
        representative,
        intermediaryPhoneNumber,
        intermediaryMailAddress
    } = props.intermediaryInfo

    return (
        <>
            <TableRow>
                <TableRowNameTop rowSpan={intermediaryMailAddress && !lmFlag ? 8 : 7}>
                    <Box fontWeight={FontWeights.Bold}>仲介業者</Box>
                </TableRowNameTop>
                <SecondaryTableRowName>
                    組合員資格変更年月日
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={3}>
                    {moment(ownershipTransferDate).format('YYYY年M月D日')}
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName rowSpan={2}>
                    管理費等の支払変更期日
                </SecondaryTableRowName>
                <SecondaryTableRowName>
                    旧組合員
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2}>
                    {moment(oldMemberPaymentChangeDate).format('YYYY年M月')}分まで支払い
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName>
                    新組合員
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2}>
                    {moment(newMemberPaymentChangeDate).format('YYYY年M月')}分から支払い
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName rowSpan={intermediaryMailAddress && !lmFlag ? 5 : 4} end>
                    仲介業者情報
                </SecondaryTableRowName>
                <SecondaryTableRowName>
                    企業名
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2}>
                    {companyName}
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName>
                    住所
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2}>
                    {getFormattedAddress(
                        intermediaryZipCode,
                        intermediaryPrefecture,
                        intermediaryAddress2,
                        intermediaryAddress3,
                        intermediaryBuildingRoomNumber
                    )}
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName>
                    担当者
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2}>
                    {representative}
                </SecondaryTableCell>
            </TableRow>
            <TableRow>
                <SecondaryTableRowName end={!(intermediaryMailAddress && !lmFlag)}>
                    電話番号
                </SecondaryTableRowName>
                <SecondaryTableCell colSpan={2} end={!(intermediaryMailAddress && !lmFlag)}>
                    {intermediaryPhoneNumber}
                </SecondaryTableCell>
            </TableRow>
            {intermediaryMailAddress && !lmFlag &&
                <TableRow>
                    <SecondaryTableRowName end>
                        メールアドレス
                    </SecondaryTableRowName>
                    <SecondaryTableCell colSpan={2} end>
                        {intermediaryMailAddress}
                    </SecondaryTableCell>
                </TableRow>
            }
        </>
    )
}